import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { DataFilterDisplayService } from '../../interface';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class DaysInputDisplayService implements DataFilterDisplayService {
  constructor(private readonly translateService: TranslateService) {}
  getDisplay(value: number): Observable<string> {
    let display = this.translateService.instant('AUTOMATIONS.EDITOR.FILTERS.USER_DATA.DATA_LABELS.X_DAY', {
      days: value,
    });
    if (value > 1) {
      display = this.translateService.instant('AUTOMATIONS.EDITOR.FILTERS.USER_DATA.DATA_LABELS.X_DAYS', {
        days: value,
      });
    }
    return of(`<b>${display}</b>`);
  }
}
